module.exports = __webpack_public_path__ + "img/category.af23197a.png";